import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const AddReturnComments = createAsyncThunk(
  "AddReturnComments/AddReturnComments",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ReturnComments/AddReturnComments",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteReturnComments = createAsyncThunk(
  "DeleteReturnComments/DeleteReturnComments",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ReturnComments/DeleteReturnComments",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ReturnToEdit = createAsyncThunk(
  "DeleteReturnComments/ReturnToEdit",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ReturnComments/ReturnToEdit",
        param
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ReturnComments = createSlice({
  name: "ReturnComments",
  initialState: {
    AddReturnComments: {},
    loadingAddReturnComments: false,
    errorAddReturnComments: null,

    DeleteReturnComments: {},
    loadingDeleteReturnComments: false,
    errorDeleteReturnComments: null,

    ReturnToEdit: {},
    loadingReturnToEdit: false,
    errorReturnToEdit: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(AddReturnComments.pending, (state, action) => {
        state.loadingAddReturnComments = true;
        state.AddReturnComments = action.payload;
        state.errorAddReturnComments = null;
      })
      .addCase(AddReturnComments.fulfilled, (state, action) => {
        state.loadingAddReturnComments = false;
        state.AddReturnComments = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddReturnComments.rejected, (state, action) => {
        state.loadingAddReturnComments = false;
        state.errorAddReturnComments = action.payload;
      });
    builder
      .addCase(DeleteReturnComments.pending, (state, action) => {
        state.loadingDeleteReturnComments = true;
        state.DeleteReturnComments = action.payload;
        state.errorDeleteReturnComments = null;
      })
      .addCase(DeleteReturnComments.fulfilled, (state, action) => {
        state.loadingDeleteReturnComments = false;
        state.DeleteReturnComments = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteReturnComments.rejected, (state, action) => {
        state.loadingDeleteReturnComments = false;
        state.errorDeleteReturnComments = action.payload;
      });

    builder
      .addCase(ReturnToEdit.pending, (state, action) => {
        state.loadingReturnToEdit = true;
        state.ReturnToEdit = action.payload;
        state.errorReturnToEdit = null;
      })
      .addCase(ReturnToEdit.fulfilled, (state, action) => {
        state.loadingReturnToEdit = false;
        state.ReturnToEdit = action.payload; // Assuming payload has the desired data
      })
      .addCase(ReturnToEdit.rejected, (state, action) => {
        state.loadingReturnToEdit = false;
        state.errorReturnToEdit = action.payload;
      });
  },
});

export default ReturnComments.reducer;
